var FALLBACK_DELAY, MAX_MOUSE_LOCS, documentListener, getSlope, mouseLocs, mousemoveDocument, noop;

MAX_MOUSE_LOCS = 3;

FALLBACK_DELAY = 300;

mouseLocs = [];

documentListener = null;

noop = function() {};

mousemoveDocument = function(e) {
  mouseLocs.push({
    x: e.pageX,
    y: e.pageY
  });
  if (mouseLocs.length > MAX_MOUSE_LOCS) {
    return mouseLocs.shift();
  }
};

getSlope = function(pointA, pointB) {
  return (pointB.y - pointA.y) / (pointB.x - pointA.x);
};


/**
 * Return instance of flyout with triangle algorithm
 *
 * @param   {Object} [options]
 * @returns {Object} - instance of flyout with activateRow and deactivateRow methods
 */

module.exports = function(options) {
  var $menuElem, activateRow, activateRowTimeout, activeRow, clearExistingTimeout, deactivateRow, delay, getActivationDelay, lastDelayLoc, mouseenterRow, mouseleaveMenu, onActivateRow, onDeactivateRow, possiblyActivateRow, rowSelector;
  $menuElem = options.$menuElem, rowSelector = options.rowSelector, delay = options.delay, onActivateRow = options.onActivateRow, onDeactivateRow = options.onDeactivateRow;
  if (!($menuElem != null ? $menuElem.find(rowSelector).length : void 0)) {
    return;
  }
  if (onActivateRow == null) {
    onActivateRow = noop;
  }
  if (onDeactivateRow == null) {
    onDeactivateRow = noop;
  }
  activeRow = null;
  activateRowTimeout = null;
  lastDelayLoc = null;
  if (delay == null) {
    delay = FALLBACK_DELAY;
  }
  mouseleaveMenu = clearExistingTimeout = function() {
    if (activateRowTimeout) {
      return clearTimeout(activateRowTimeout);
    }
  };

  /**
   * Set active row within a menu
   *
   * @param   {Object} - jQuery row elem to set active within a flyout instance
   * @returns {Object} - jQuery row elem that is now active
   */
  activateRow = function(newActiveRow) {
    if (newActiveRow === activeRow) {
      return;
    }
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    onActivateRow(newActiveRow);
    return activeRow = newActiveRow;
  };

  /**
   * Deactivate current active row
   *
   * @returns {null}
   */
  deactivateRow = function() {
    if (activeRow) {
      onDeactivateRow(activeRow);
    }
    return activeRow = null;
  };
  getActivationDelay = function() {
    var currentLoc, decreasingSlope, increasingSlope, menuBottomRight, menuUpperRight, offset, prevDecreasingSlope, prevIncreasingSlope, prevLoc;
    if (!activeRow) {
      return 0;
    }
    offset = $menuElem.offset();
    menuUpperRight = {
      x: offset.left + $menuElem.outerWidth(),
      y: offset.top - 75
    };
    menuBottomRight = {
      x: menuUpperRight.x,
      y: offset.top + $menuElem.outerHeight() + 75
    };
    if ((currentLoc = mouseLocs[mouseLocs.length - 1]) == null) {
      return 0;
    }
    prevLoc = mouseLocs[0];
    if (prevLoc.x < offset.left || prevLoc.x > menuBottomRight.x || prevLoc.y < offset.top || prevLoc.y > menuBottomRight.y) {
      return 0;
    }
    if (lastDelayLoc && currentLoc.x === lastDelayLoc.x && currentLoc.y === lastDelayLoc.y) {
      return 0;
    }
    decreasingSlope = getSlope(currentLoc, menuUpperRight);
    increasingSlope = getSlope(currentLoc, menuBottomRight);
    prevDecreasingSlope = getSlope(prevLoc, menuUpperRight);
    prevIncreasingSlope = getSlope(prevLoc, menuBottomRight);
    if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
      lastDelayLoc = currentLoc;
      return delay;
    } else {
      lastDelayLoc = null;
      return 0;
    }
  };
  possiblyActivateRow = function(rowElem) {
    var activationDelay;
    activationDelay = getActivationDelay();
    if (activationDelay) {
      return activateRowTimeout = setTimeout((function() {
        return possiblyActivateRow(rowElem);
      }), activationDelay);
    } else {
      return activateRow(rowElem);
    }
  };
  mouseenterRow = function() {
    clearExistingTimeout();
    return possiblyActivateRow(this);
  };
  $menuElem.on('mouseleave', mouseleaveMenu).find(rowSelector).on('mouseenter', mouseenterRow);
  if (documentListener == null) {
    documentListener = $(document).on('mousemove', mousemoveDocument);
  }
  return {
    activateRow: activateRow,
    deactivateRow: deactivateRow
  };
};

